/**
 * https://msstart-games-sdk-doc.azurewebsites.net/docs/sdk-apis/cloud-saves
 *
 * https://www.msn.com/en-us/play/games/testing/cg-test-game?dev-playground=https://tripeaks-staging.labsystech.ru/publish/html5-staging/msstart
 *
 * Created by andrey on 23.09.2025
 */

const MSStartCloudStorage = function () {
    this.data = undefined;
    this.batch = undefined;

    this.flush = connector.utils.accumulate(1000, this._flush.bind(this));
    this.sendStatistics = connector.utils.accumulate(60000, this._sendStatistics.bind(this));
};

MSStartCloudStorage.prototype.connect = function (callback) {
    const player = new ConnectorActionPlayer([
        (f, stop) => {
            if (connector.platform.isConnected()) {
                f();
                return;
            }

            const handler = connector.platform.once("changeStatus", connector.utils.waitNoMore(10000, () => {
                handler.clear();

                if (connector.platform.isConnected()) {
                    f();
                } else {
                    stop();
                }
            }));

            connector.platform.connect();
        },

        (f, stop) => {
            $msstart.getSignedInUserAsync()
                .then((player) => {
                    const result = Boolean(player.publisherPlayerId || player.playerId);
                    console.log(`cloud storage available - ${result}`);
                    if (result) {
                        f();
                    } else {
                        stop(connector.ERRORS.NOT_SIGNED_IN);
                    }
                })
                .catch((error) => {
                    console.log("cloud storage error", error);
                    stop(connector.ERRORS.NOT_SIGNED_IN);
                });
        },

        (f, stop) => {
            connector.metrics.logEvent(connector.EVENTS.CLOUD_STORAGE.LOAD);

            const start = Date.now();

            $msstart.cloudSave.getDataAsync({
                gameId: connector.config.projectId
            }).then((data) => {
                this.data = data || {};

                const kb = Math.ceil(JSON.stringify(this.data).length / 1024);

                console.log(`cloud data ${kb}kb loaded ${Date.now() - start}ms `);
                connector.config.debugMode && console.log("cloud", data);

                connector.metrics.logEvent(connector.EVENTS.CLOUD_STORAGE.LOAD_SUCCESS);

                const bucket = [100, 200, 500, 1000, 10000].find((size) => kb <= size) || 10000;
                connector.metrics.logEvent(connector.EVENTS.CLOUD_STORAGE.DATA_SIZE_BUCKET + bucket);

                f();
            }).catch((error) => {
                console.log("error retrieving cloud data", error);

                stop(ERRORS.STORAGE.LOAD.UNKNOWN);
            });
        }
    ]);

    player.onFailure((code) => {
        callback(code || connector.CODE_FAILED);
    });

    player.onSuccess(() => {
        this.connected = true;
        callback(connector.CODE_SUCCEED);
    });

    player.play();
};

MSStartCloudStorage.prototype.getItem = function (key) {
    return this.data[key];
};

MSStartCloudStorage.prototype.setItem = function (key, value) {
    if (value === undefined || typeof value === "number" && isNaN(value)) {
        console.warn(`cloud incorrect value ${typeof value}`, value);
        return;
    }

    if (this.data[key] === value) {
        return;
    }

    this.data[key] = value;

    this.batch = this.batch || {};
    this.batch[key] = value;

    this.flush();
};

MSStartCloudStorage.prototype.removeItem = function (key) {
    if (this.data[key] === undefined) {
        return;
    }

    delete this.data[key];

    this.batch = this.batch || {};
    this.batch[key] = null;

    this.flush();
};

MSStartCloudStorage.prototype.getData = function (prefix = "") {
    const data = {};
    for (const key in this.data) {
        if (key.startsWith(prefix)) {
            data[key] = this.data[key];
        }
    }
    return data;
};

MSStartCloudStorage.prototype.clearData = function (prefix = "") {
    for (const key in this.data) {
        if (key.startsWith(prefix)) {
            this.removeItem(key);
        }
    }
};

MSStartCloudStorage.prototype._flush = function () {
    if (this.flushing || !this.batch) {
        return;
    }

    if (this.flushErrorTime && this.flushErrorTime + MSStartCloudStorage.FLUSH_AFTER_ERROR_TIME > Date.now()) {
        return;
    }

    const batch = this.batch;
    this.batch = undefined;

    this.flushing = true;

    // const start = Date.now();

    this.saveCount = (this.saveCount || 0) + 1;
    this.sendStatistics();

    $msstart.cloudSave.saveDataAsync({
        gameId: connector.config.projectId,
        data: batch
    }).then(() => {
        // console.log(`cloud save success ${Date.now() - start}ms`, batch);

        this.saveSuccessCount = (this.saveSuccessCount || 0) + 1;
    }).catch((error) => {
        console.log("cloud save error", error);
        connector.config.debugMode && console.log("cloud", batch);

        this.flushErrorTime = Date.now();

        this.batch = { ...batch, ...this.batch };
    }).finally(() => {
        this.flushing = false;
        this.flush();
    });
};

MSStartCloudStorage.prototype._sendStatistics = function () {
    if (this.saveCount) {
        connector.metrics.logEvent(connector.EVENTS.CLOUD_STORAGE.SAVE, { value: this.saveCount });
    }

    if (this.saveSuccessCount) {
        connector.metrics.logEvent(connector.EVENTS.CLOUD_STORAGE.SAVE_SUCCESS, { value: this.saveSuccessCount });
    }

    this.saveCount = 0;
    this.saveSuccessCount = 0;
};

MSStartCloudStorage.FLUSH_AFTER_ERROR_TIME = connector.utils.parseInterval("30 seconds");